module.exports = __webpack_public_path__ + "static/media/banner-azul-mobile.442488b4.png";